
<script>
  export let indexCounterCaption;
  export let indexCounterMaxNumber;
  export let indexCounterUnit;
  export let svgName;
  import Marketcap from './../svgs/marketcap.svelte';
  import Dollar from './../svgs/dollar.svelte';
  import Tvl from './../svgs/tvl.svelte';
	import { onMount } from 'svelte';

  $: indexCounterText=0;

  function animateValue(start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      if(indexCounterUnit == 'format') {
        indexCounterText = Intl.NumberFormat('en', { notation: 'compact' }).format(progress * (end - start) + start);
      }
      else if (indexCounterUnit == 'dollar') {
        indexCounterText = '$' + (progress * (end - start) + start).toFixed(2);
      }
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }

  onMount(async () => {
    animateValue(0.0, indexCounterMaxNumber, 2000);
  });

</script>

<div class="flex flex-row space-x-5 justify-center pt-4  border-red-800" style='padding:0 50px;!important'>
  <div class="bg-black/50 text-yellow-200 h-20 w-20 p-6 rounded-full">
      <svelte:component this={eval(svgName)} />
    </div>
  <div class="felx flex-col my-auto justify-start space-y-2">
      <h1 class="text-4xl font-bold">
        { indexCounterText }
      </h1>
      <p class="opacity-80 text-sm">
        { indexCounterCaption }
      </p>
  </div>
</div>
